import { render, staticRenderFns } from "./MenusList.vue?vue&type=template&id=38023aa4&scoped=true&"
import script from "./MenusList.vue?vue&type=script&lang=js&"
export * from "./MenusList.vue?vue&type=script&lang=js&"
import style0 from "./MenusList.vue?vue&type=style&index=0&id=38023aa4&lang=scss&scoped=true&"
import style1 from "./MenusList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38023aa4",
  null
  
)

export default component.exports